import type { FaireProductEntity } from "../../entity_types/product";

export const p_rz3n2dckvs: FaireProductEntity = {
  token: "p_rz3n2dckvs",
  type: "product",
  name: "Oatmeal GAME DAY Letter Graphic Varsity Striped Detail Baggy Sweatshirt",
  brandToken: "b_t9mynp4xpd",
  brandName: "Lovesoft",
  imageUrl:
    "https://cdn.faire.com/fastly/3bc645e21cc8faaa675e3091af7de40be1eaa63a671c254a950e4811adac2de3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/13ef72b3e5796d6dad5403422f28c408e409f43707fab92a14875bcdea5eabe9.jpeg",
    "https://cdn.faire.com/fastly/b88633989b41b604814279112ba1f5441d82f400f34f51c4cdc42241c9d175b4.jpeg",
    "https://cdn.faire.com/fastly/41aa233efd55e0840c8de8f348a592e20ea1f2c9e2eb31f175129872bb4d94a1.jpeg",
    "https://cdn.faire.com/fastly/e7b7febf4e415dfe3a33370eb8032768d6d77156a5e014ec7e6665689a417984.jpeg",
    "https://cdn.faire.com/fastly/bbf8cef3a51ea7bbd2acae4dba29e3aba363966e88f2c248b7111451b9b24e6a.jpeg",
    "https://cdn.faire.com/fastly/67ebdc1151a1cdb0bba7960b0101de153f988379684db514607e73f8e459f2ea.jpeg",
    "https://cdn.faire.com/fastly/2bc80473f0a5d67ecac39c4325e5e8369789506a65f45a1fa7045987cd6f3b59.jpeg",
    "https://cdn.faire.com/fastly/447eeba36f9eecdd5ffd1fca21ae6c97318ed2d0171c9ef5c35d04a7431521aa.jpeg",
    "https://cdn.faire.com/fastly/9aab243c601b5e9b90619613818e3466fbfdb130808aa029d3f3eb0f94fecc23.jpeg",
    "https://cdn.faire.com/fastly/38bf8502f728ae5d456c3c52864c7707fb9914bcc6524caec7b3c7133e34616b.jpeg",
    "https://cdn.faire.com/fastly/66d4b344cc06de428260f505774933ddb5b8705a84e614aa2b471ebcb66e331b.webp",
    "https://cdn.faire.com/fastly/63d483745e3d1d7bb20a744aeb210a973977dd1a636f6fb7b5c4f04bac7e4c11.webp",
    "https://cdn.faire.com/fastly/04cd70774e156f8cfa8e8bfe868bf71b3c299ca6fd8f7cd70f5e24b6ede996c7.png",
  ],
  priceDollars: 18.59,
  description:
    "This preppy sweatshirt is perfect for the Game season.\nFeatures a vintage letter graphic printed on the front.\nVarsity striped banding details at neckline, hemline, and cuffs.\nMade of quality cotton blend fabric in a comfy loose silhouette.\n\nBrand labels are not included by default. If needed, please add them via this link ($0.50/pc): https://www.faire.com/product/p_kzks8vegvk",
  tags: [],
  msrpDollars: 37.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:26.822Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
